import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  const [hoveredCategory, setHoveredCategory] = useState(null);

  return (
    <div className="bg-card/50 backdrop-blur-sm border border-border rounded-2xl p-6 shadow-3d">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-8 h-8 bg-accent/20 rounded-lg flex items-center justify-center">
          <Icon name="Filter" size={16} className="text-accent" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Categories</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3">
        {categories?.map((category, index) => (
          <motion.button
            key={category?.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            onClick={() => onCategoryChange(category?.id)}
            onMouseEnter={() => setHoveredCategory(category?.id)}
            onMouseLeave={() => setHoveredCategory(null)}
            className={`relative group flex items-center space-x-3 p-4 rounded-xl transition-all duration-300 text-left ${
              activeCategory === category?.id
                ? 'bg-accent/10 border border-accent/30 shadow-accent'
                : 'bg-muted/30 hover:bg-muted/50 border border-transparent'
            }`}
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 ${
              activeCategory === category?.id
                ? 'bg-accent/20 text-accent' :'bg-muted text-muted-foreground group-hover:bg-accent/10 group-hover:text-accent'
            }`}>
              <Icon name={category?.icon} size={18} />
            </div>

            <div className="flex-1 min-w-0">
              <div className={`font-medium transition-colors duration-300 ${
                activeCategory === category?.id
                  ? 'text-accent' :'text-foreground group-hover:text-accent'
              }`}>
                {category?.name}
              </div>
              <div className="text-xs text-muted-foreground mt-1 line-clamp-1">
                {category?.description}
              </div>
              <div className="flex items-center space-x-2 mt-2">
                <span className="text-xs text-muted-foreground">
                  {category?.count} articles
                </span>
                {category?.isNew && (
                  <span className="px-2 py-0.5 bg-success/20 text-success text-xs rounded-full">
                    New
                  </span>
                )}
              </div>
            </div>

            {/* 3D Hover Effect */}
            <motion.div
              className="absolute inset-0 rounded-xl bg-gradient-to-r from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              animate={{
                scale: hoveredCategory === category?.id ? [1, 1.02, 1] : 1,
              }}
              transition={{ duration: 0.3 }}
            />

            {activeCategory === category?.id && (
              <motion.div
                layoutId="activeCategory"
                className="absolute inset-0 rounded-xl border-2 border-accent/50"
                initial={false}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
              />
            )}
          </motion.button>
        ))}
      </div>
      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center">
            <div className="text-2xl font-bold text-accent">200+</div>
            <div className="text-xs text-muted-foreground">Total Articles</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-success">50+</div>
            <div className="text-xs text-muted-foreground">This Month</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;